// extracted by mini-css-extract-plugin
module.exports = {"container":"BaseTable_container_2r7Rh","tableScroll":"BaseTable_tableScroll_1XQIq","tableFooter":"BaseTable_tableFooter_3p86L","borderless":"BaseTable_borderless_20IT0"};